import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Schools from './Schools';
import GlobalUsers from './GlobalUsers';
import Backup from './Backup';
import ProfileModal from './ProfileModal';

// The FullAdmin-only global admin area — school creation, all-users
// management, and database backup, none of which is scoped to any single
// school. Deliberately a separate route (/admin/main) from
// /admin/:schoolId/* rather than pages squeezed into that school-scoped
// shell, and gated by ProtectedRoute's requireFullAdmin (see App.js) so
// SchoolAdmins can't reach it even by URL.
const NAV_ITEMS = [
  { suffix: '/schools', label: '🏫 Schools' },
  { suffix: '/users', label: '👥 Users' },
  { suffix: '/backup', label: '💾 Backup' }
];

function MainAdminDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [showProfile, setShowProfile] = useState(false);

  const base = '/admin/main';
  const isActive = (suffix) => location.pathname === `${base}${suffix}`;

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div>
      <header className="header no-print">
        <div className="admin-topbar">
          <div className="admin-topbar-left">
            <h1>🥪 Admin Area</h1>
          </div>
          <div className="admin-topbar-right">
            <Link
              to="/admin"
              style={{ color: '#ccd6e0', fontSize: '0.9rem', textDecoration: 'none' }}
            >
              ← Back to a school
            </Link>
            <span className="nav-welcome" style={{ color: '#ccd6e0', fontSize: '0.9rem' }}>
              Welcome, {user?.username}
            </span>
            <button
              onClick={() => setShowProfile(true)}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'transparent',
                color: '#ccd6e0',
                border: '1px solid #ccd6e0',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9rem'
              }}
            >
              👤 Profile
            </button>
            <button
              onClick={handleLogout}
              style={{
                padding: '0.5rem 1rem',
                backgroundColor: '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.9rem'
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      {showProfile && (
        <ProfileModal onClose={() => setShowProfile(false)} />
      )}

      <div className="admin-body">
        <nav className="sidebar">
          {NAV_ITEMS.map(item => (
            <Link
              key={item.suffix}
              to={`${base}${item.suffix}`}
              className={`sidebar-link ${isActive(item.suffix) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="admin-content">
          {isActive('/users') ? <GlobalUsers />
            : isActive('/backup') ? <Backup />
            : <Schools />}
        </div>
      </div>
    </div>
  );
}

export default MainAdminDashboard;
